import { defaultFetchParams } from '../common/fixtures';
import { DropdownOption, defaultOption } from '../adapters/types';
import create from 'zustand';
import { stringToBase64Url } from '@okta/okta-auth-js/types/lib/crypto';
import { partItem } from '../common/types';
import { Moment } from 'moment';

 


export interface AppState {

  selectedGroup: any;
  setSelectedGroup: (option: any) => void;
  isPanelCollapsed: boolean;
  setPanelCollapsed: (flag: boolean) => void;
  selectedRows :any;
  setSelectedRows :(data :partItem[]) => void
  selectedStatus:  string[];
  selectedFlag:  string[];
  setSelectedStatus: (status:  string[]) => void;
  setSelectedFlag: (important:  string[]) => void;
  dateFrom: Moment | null;
  dateTo: Moment | null;
  setDateFrom: (date: Moment | null) => void;
  setDateTo: (date: Moment | null) => void;
  
}

export const useAppState = create<AppState>()(set => ({

  selectedGroup: {
    groupName: {
      label: '',
      value: '',
      storeId: '',
      department: '',
      isDefaultStore: false
    }
  },
  
  setSelectedGroup: option => {
    set(state => ({
      ...state, selectedGroup: {
        groupName:option
      }
    }));
  },

  isPanelCollapsed: true,
  setPanelCollapsed: flag => {
    set(state => ({ ...state, isPanelCollapsed: flag }));
  },

  selectedRows: {
    partItem:[]
  },

  setSelectedRows: (items: partItem[]) => set(() => ({
    selectedRows: items
    
  })),

  selectedStatus: [],
  selectedFlag: [],
  setSelectedStatus: (status) => set({ selectedStatus: status }),
  setSelectedFlag: (important) => set({ selectedFlag: important }) ,

  dateFrom: null,
  dateTo: null,
  setDateFrom: (date) => set({ dateFrom: date }),
  setDateTo: (date) => set({ dateTo: date }),

}));
